import styled from 'styled-components';

export const Page = styled.div``;

export const Header = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0; padding: 0 16px;
  display: grid; grid-template-columns: 1fr 1fr; gap: 16px;
  @media (max-width: 900px){ grid-template-columns: 1fr; }
`;

export const HeaderCard = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px; padding: 18px;
  h1{ margin:0 0 6px; color: ${({ theme }) => theme.colors.green[700]}; }
  p{ margin: 0; }
`;

export const HeaderImage = styled.div`
  border-radius: 12px; overflow: hidden; background: ${({ theme }) => theme.colors.gray[100]}; min-height: 220px;
  img{ width:100%; height:100%; object-fit: cover; }
`;

export const Section = styled.section`
  max-width: ${({ theme }) => theme.container};
  margin: 24px auto 0; padding: 0 16px;
  display: grid; grid-template-columns: 1fr 1fr; gap: 16px;
  @media (max-width: 900px){ grid-template-columns: 1fr; }
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.gray[200]};
  border-radius: 12px; padding: 18px; box-shadow: ${({ theme }) => theme.shadows.sm};
`;

export const Field = styled.div`
  margin-bottom: 12px;
  label{ display:block; margin-bottom: 6px; color: ${({ theme }) => theme.colors.text}; }
  input, textarea{
    width: 100%; padding: 12px; border: 1px solid ${({ theme }) => theme.colors.gray[300]}; border-radius: 10px; background: #fff;
  }
  textarea{ min-height: 120px; resize: vertical; }
`;

export const Button = styled.button`
  padding: 12px 16px; border:none; border-radius: 10px; background: ${({ theme }) => theme.colors.green[600]}; color:#fff; font-weight:600; cursor:pointer;
`;

export const InfoItem = styled.div`
  margin-bottom: 10px; line-height: 1.6;
  strong{ color: ${({ theme }) => theme.colors.green[700]}; }
`;

export const SocialLinksRow = styled.div`
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SocialIconLink = styled.a`
  width: 36px;
  height: 36px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.green[50]};
  color: ${({ theme }) => theme.colors.green[700]};
  border: 1px solid ${({ theme }) => theme.colors.green[100]};
  text-decoration: none;
  transition: background 0.15s ease-in-out, color 0.15s ease-in-out, transform 0.15s ease-in-out;
  svg{ font-size: 18px; }
  &:hover{
    background: ${({ theme }) => theme.colors.green[600]};
    color: #fff;
    transform: translateY(-1px);
  }
`;
